import Twig from 'twig';
import Scrollbar from './scrollbar.js';
import Media from './../mediaDetect.js'; //Детектор медиа
import './../libs/datepicker-en.js'; // Английская локализация
import './../libs/datepicker-ru.js'; // Русская локализация

/*
 * Компонент календарь - попап с выбором даты от и до,
 * создает событие change:calendar,
 * которое содержат объект IntervalCalendarFilter = {
    dateStart: '', // от даты
    dateFinish: '' // до даты
 }
*/

let langId = window.langId,
    formatDatepicker,
    dividerDatepicker;

let IntervalCalendarFilter = {
    dateStart: '', // глобальная дата, которая передаётся в качестве параметра фильтрации
    dateFinish: '' // глобальная дата, которая передаётся в качестве параметра фильтрации
}

let hiddenDateStart = '', // вспомогательная дата, хранящая текущее значение календаря
    hiddenDateFinish = '', // вспомогательная дата, хранящая текущее значение календаря
    currentInputDatepicker;

let IntervalCalendar = {
    initTabs: function(currTab, tabs){
        if(!currTab.hasClass('active')) {

            // Отображение активного таба
            tabs.removeClass('active');
            currTab.addClass('active');

            let typeTab = currTab.data('interval-tab-calendar-filter'),
                currDate = new Date();

            // По клику на одном из табов рассчитываем начальную и конечную даты,
            // вызываем функцию устанавливающую эти даты
            // (в календаре, скрытых инпутах, в интервале значений)
            switch(typeTab) {
                case 'today':
                    IntervalCalendar.setDateDatepicker(currDate, currDate);
                    break;

                case 'week':
                    let week = new Date();
                    week.setDate(currDate.getDate() + 6);
                    IntervalCalendar.setDateDatepicker(currDate, week);
                    break;

                case 'month':
                    let month = new Date();
                    month.setMonth(currDate.getMonth() + 1, currDate.getDate() - 1);
                    IntervalCalendar.setDateDatepicker(currDate, month);
                    break;

                case 'year':
                    let year = new Date();
                    year.setFullYear(currDate.getFullYear() + 1, currDate.getMonth(), currDate.getDate() - 1);
                    IntervalCalendar.setDateDatepicker(currDate, year);
                    break;

                case 'half-year':
                    let halfYear = new Date();
                    halfYear.setMonth(currDate.getMonth() + 6, currDate.getDate() - 1);
                    IntervalCalendar.setDateDatepicker(currDate, halfYear);
                    break;

                default:
                    break;
            }
        }
    },
    initIntervalCalendar: function(calendar){
        calendar.datepicker({
            dateFormat: 'dd.mm.yy',
            //showOtherMonths: true,
            //selectOtherMonths: false,
            //changeMonth: true,
            //changeYear: true,
            //showMonthAfterYear: false,
            yearRange: 'c-4:c+4',
            changeMonth: false,
            changeYear: false,
            firstDay: 1,
            isRTL: false,
            numberOfMonths: 2,
            yearSuffix: '',
            range: 'period', // возможные значения: period, multiple
            range_multiple_max: 2, // максимальное число выбранных дат в режиме "Несколько дат"
            onSelect: function(date, inst, extensionRange) {
                //$('[data-interval-tab-calendar-filter]').removeClass('active');

                if(hiddenDateStart) {
                    var oldStartDate = new Date(hiddenDateStart).getTime(),
                        newStartDate = new Date(calendar.datepicker("getDate")).getTime();

                    if(oldStartDate > newStartDate) {
                        extensionRange.step = 1;
                        extensionRange.endDate = extensionRange.startDate;
                        extensionRange.endDateText = extensionRange.startDateText;
                    }
                }

                IntervalCalendar.setDateDatepicker(extensionRange.startDate, extensionRange.endDate, true);

                /*setTimeout(function(){
                    IntervalCalendar.initSelectizeInIntervalCalendar(calendar.find('select'));
                }, 100);*/
            }/*,
            onChangeMonthYear: function(year, month, inst){
                setTimeout(function(){
                    IntervalCalendar.initSelectizeInIntervalCalendar(calendar.find('select'));
                }, 100);
            },
            beforeShowDay: function(date){
                var currDateMs = new Date(date).setHours(0,0,0,0),
                    dateStartMs = new Date(hiddenDateStart).setHours(0,0,0,0),
                    dateFinishMs = new Date(hiddenDateFinish).setHours(0,0,0,0);

                if((currDateMs >= dateStartMs) && (currDateMs <= dateFinishMs)) {
                    return [true, 'select-interval'];
                }

                return [true, ''];
            }*/
        });

        formatDatepicker = $.datepicker.regional[(langId == 'en' ? 'en-US' : langId)].dateFormat;
        dividerDatepicker = (formatDatepicker.indexOf('.') > 0 ? '.' : '/');

        /*setTimeout(function(){
            IntervalCalendar.initSelectizeInIntervalCalendar(calendar.find('select'));
        }, 100);*/
    },
    /*initSelectizeInIntervalCalendar: function(selects){
        selects.selectize({
            onChange: function(value){
                var elem = this.$input[0],
                    container = $(elem).closest('.ui-datepicker-title');

                // fix бага selectize с выбранным элементом
                container.find('.option').removeClass('selected');
                container.find('[data-interval-value="'+value+'"].option').addClass('selected');
            },
            onDropdownOpen: function (dropdown) {
                var self = this;

                $(dropdown)
                  .css('width', this.$control[0].offsetWidth + 'px')
                  .css('top', this.$control[0].offsetHeight + 'px')
                  .css('visibility', 'visible')
                  .css('opacity', '1');

                $(dropdown).addClass('has-scrollbar');
                $(dropdown).find('.selectize-dropdown-content').addClass('nano-content');

                setTimeout(function(){
                    $(dropdown).nanoScroller({scroll: 'top'});
                    self.$dropdown[0].nanoscroller.reset();
                }, 100);
            },
            onDropdownClose: function (dropdown) {
                $(dropdown).css('visibility', 'hidden').css('opacity', '0');

                setTimeout(function () {
                    $(dropdown).prev().find('input').blur();
                }, 250);
            },
            onInitialize: function (value) {
                this.$dropdown.css('visibility', 'hidden').css('opacity', '0');
            }
        });
    },*/
    templateItemIntervalCalendar: function(){
        var sublist = IntervalCalendar.templateSublistItemIntervalCalendar();
        var template = Twig.twig({
                data:   '<div class="item" data-interval-item-calendar-list="true">'+
                            '<h2 class="item__month upper" data-interval-month-calendar-list="true">{{ data.month|raw }}</h2>'+
                            '<div class="item__list" data-interval-sublist-calendar-list="true">'+
                                sublist +
                            '</div>'+
                        '</div>'
            });

        return template;
    },
    templateSublistItemIntervalCalendar: function(){
        var template =  '{% for item in data.list %}'+
                            '<div class="event-card-full {{(item.isOwnExhibition ? \'event-card-full__own-exhibition\')}}" data-interval-full-event-card="true">'+
                                '<div class="row" data-interval-full-event-card-content="true">'+
                                    '<div class="event-card-full__top col-12 d-block d-md-none">'+
                                        '<a href="{{item.link}}" class="event-card-full__date">'+
                                            '{{item.dateInterval|raw}}'+
                                        '</a>'+
                                        '{% if item.addIntervalCalendarLink|length %}'+
                                            '<a href="{{item.addIntervalCalendarLink}}" class="event-card-full__add-calendar">'+
                                                '<span class="svg-icon">'+
                                                    '<svg>'+
                                                        '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-calendar"></use>'+
                                                    '</svg>'+
                                                '</span>'+
                                            '</a>'+
                                        '{% endif %}'+
                                    '</div>'+
                                    '<div class="col-12 col-md-2">'+
                                        '{% if item.logo|length %}'+
                                            '<a href="{{item.link}}" class="event-card-full__logo">'+
                                                '<img src="{{item.logo}}" />'+
                                            '</a>'+
                                        '{% endif %}'+
                                    '</div>'+
                                    '<div class="col-12 col-md-6 col-lg-7">'+
                                        '<a href="{{item.link}}" class="event-card-full__content">'+
                                            '<div class="event-card-full__type">{{item.type|raw}}</div>'+
                                            '<div class="event-card-full__title">{{item.title|raw}}</div>'+
                                            '<div class="event-card-full__descr">{{item.descr|raw}}</div>'+
                                            '<div class="event-card-full__organizer">'+
                                                '<div class="event-card-full__organizer-title">{{item.organizerTitle|raw}}:</div>'+
                                                '<div class="event-card-full__organizer-name">{{item.organizer|raw}}</div>'+
                                            '</div>'+
                                        '</a>'+
                                    '</div>'+
                                    '<div class="col-12 col-md-4 col-lg-3 d-none d-md-block">'+
                                        '<a href="{{item.link}}" class="event-card-full__date">'+
                                            '{{item.dateInterval|raw}}'+
                                        '</a>'+
                                        '{% if item.addIntervalCalendarLink|length %}'+
                                            '<a href="{{item.addIntervalCalendarLink}}" class="event-card-full__add-calendar">'+
                                                '<span class="svg-icon">'+
                                                    '<svg>'+
                                                        '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-calendar"></use>'+
                                                    '</svg>'+
                                                '</span>'+
                                                '<span class="text">{{ data.addToIntervalCalendar }}</span>'+
                                            '</a>'+
                                        '{% endif %}'+
                                        '{% if item.place|length %}'+
                                            '<a href="{{item.link}}" class="event-card-full__place">'+
                                                '<span class="svg-icon">'+
                                                    '<svg>'+
                                                        '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-pin"></use>'+
                                                    '</svg>'+
                                                '</span>'+
                                                '<span class="text">{{item.place|raw}}</span>'+
                                            '</a>'+
                                        '{% endif %}'+
                                    '</div>'+
                                '</div>'+
                            '</div>'+
                        '{% endfor %}';

        return template;
    },
    setDateDatepicker: function(startDate, finishDate, noSetValueDatepicker){
        // Устанавливает в календаре переданные значения дат startDate и finishDate
        // и обновляет интервал дат внутри попапа
        let calendar = $('[data-interval-datepicker-calendar]'),
            htmlStartDate = startDate.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' }),
            htmlFinishDate = finishDate.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' });

        hiddenDateStart = startDate;
        hiddenDateFinish = finishDate;

        if(!noSetValueDatepicker) {
            calendar.datepicker('setDate', [startDate, finishDate]);
        }

        $('[data-interval-selected-dates]').html(htmlStartDate + ' - ' + htmlFinishDate);
    },
    setGlobalDate: function(currentInput){
        // Устанавливает глобальные даты календаря фильтра CalendarFilter.dateStart и CalendarFilter.dateFinish
        // и отображает интервал дат в списке
        let htmlStartDate = hiddenDateStart.toLocaleDateString(langId, {year: 'numeric', month: 'numeric', day: 'numeric' }),
            htmlFinishDate = hiddenDateFinish.toLocaleDateString(langId, {year: 'numeric', month: 'numeric', day: 'numeric' });

        IntervalCalendarFilter.dateStart = hiddenDateStart;
        IntervalCalendarFilter.dateFinish = hiddenDateFinish;

        currentInput.val(htmlStartDate + ' - ' + htmlFinishDate);
    },
    resetSelectDatepicker: function(){
        // Сбрасывает установки календаря, до исходных настроек
        if((IntervalCalendarFilter.dateStart != '') && (IntervalCalendarFilter.dateFinish != '')) {
            IntervalCalendar.setDateDatepicker(IntervalCalendarFilter.dateStart, IntervalCalendarFilter.dateFinish);
        } else {
            IntervalCalendar.setDateDatepicker(new Date(), new Date(), false);
            $('[data-interval-content-popup-calendar-filter]').find('.select-interval').removeClass('select-interval');
        }
    },
    setParseIntervalDate: function(field) {
        var fieldDateRange = field.val(),
            paramArr = fieldDateRange.split(' - '),
            from = paramArr[0],
            to = paramArr[1];

        var dateStart = IntervalCalendar.stringToDate(from, formatDatepicker, dividerDatepicker),
            dateFinish = IntervalCalendar.stringToDate(to, formatDatepicker, dividerDatepicker);

        IntervalCalendar.setDateDatepicker(dateStart, dateFinish);
    },
    stringToDate: function(_date, _format, _delimiter) {
        var formatLowerCase = _format.toLowerCase();
        var formatItems = formatLowerCase.split(_delimiter);
        var dateItems = _date.split(_delimiter);
        var monthIndex = formatItems.indexOf('mm');
        var dayIndex = formatItems.indexOf('dd');
        var yearIndex = formatItems.indexOf('yy');
        var month = parseInt(dateItems[monthIndex]);
        month -= 1;
        var formatedDate = new Date(dateItems[yearIndex],month,dateItems[dayIndex]);
        return formatedDate;
    },
    ScrollTabs: {
        // плагин iScroll
        setArrow: function(myScrollIntervalCalendarTab, left, right){
            if (myScrollIntervalCalendarTab.x == 0) {
                left.hide();
            } else if (myScrollIntervalCalendarTab.x < 0) {
                left.show();
            }
            if (myScrollIntervalCalendarTab.x == myScrollIntervalCalendarTab.maxScrollX) {
                right.hide();
            } else if (myScrollIntervalCalendarTab.x > myScrollIntervalCalendarTab.maxScrollX) {
                right.show();
            }
        },
        updateScrollContent: function(myScrollIntervalCalendarTab) {
            setTimeout(function () {
                var $wrapper = $(myScrollIntervalCalendarTab.wrapper),
                    $left = $wrapper.find('.scroll-left'),
                    $right = $wrapper.find('.scroll-right'),
                    $tabContent = $wrapper.find('.scroll-content');

                $tabContent.css('min-width', IntervalCalendar.ScrollTabs.minWidthTabs($wrapper) + 'px');

                myScrollIntervalCalendarTab.refresh();
                IntervalCalendar.ScrollTabs.setArrow(myScrollIntervalCalendarTab, $left, $right);
            }, 0);
        },
        initScrollContent: function(elem, myScrollIntervalCalendarTab) {
            myScrollIntervalCalendarTab = new IScroll(elem, {
                eventPassthrough: true,
                scrollX: true,
                scrollY: false,
                preventDefault: false,
                scrollbars: 'custom'
            });

            var $scroller = $(elem).find('.scroll-content'),
                $left = $(elem).find('.scroll-left'),
                $right = $(elem).find('.scroll-right');

            IntervalCalendar.ScrollTabs.setArrow(myScrollIntervalCalendarTab, $left, $right);

            $left.on('click', function(){
                var step_scroll = (Math.abs(myScrollIntervalCalendarTab.maxScrollX)/2 < 100 ? Math.abs(myScrollIntervalCalendarTab.maxScrollX) : Math.abs(myScrollIntervalCalendarTab.maxScrollX)/2 + 10),
                    x = (Math.abs(myScrollIntervalCalendarTab.x) > step_scroll ? step_scroll : Math.abs(myScrollIntervalCalendarTab.x));

                myScrollIntervalCalendarTab.scrollBy(x, 0, parseInt(x/10));
            });

            $right.on('click', function(){
                var step_scroll = (Math.abs(myScrollIntervalCalendarTab.maxScrollX)/2 < 100 ? Math.abs(myScrollIntervalCalendarTab.maxScrollX) : Math.abs(myScrollIntervalCalendarTab.maxScrollX)/2 + 10),
                    x_max = Math.abs(myScrollIntervalCalendarTab.maxScrollX) - Math.abs(myScrollIntervalCalendarTab.x),
                    x = (x_max < step_scroll ? x_max : step_scroll);

                myScrollIntervalCalendarTab.scrollBy(-1*x, 0, parseInt(x/10));
            });

            myScrollIntervalCalendarTab.on('scrollEnd', function() {
                IntervalCalendar.ScrollTabs.setArrow(this, $left, $right);
            });

            $(window).on('resize', function(){
                IntervalCalendar.ScrollTabs.updateScrollContent(myScrollIntervalCalendarTab);
            });
        },
        minWidthTabs: function(tabsNav){
            // Определяем минимальную ширину текущей навигации таба
            var minWidth = 0;
            tabsNav.find('[data-interval-tab-calendar-filter]').each(function(index, value){
                minWidth += $(this).outerWidth(true);
            });

            return minWidth;
        }
    },
    Popup: {
        init: function(popupIntervalCalendar){
            $('[data-interval-btn-dates-calendar-filter]').on('click', function(e){
                e.preventDefault();

                IntervalCalendar.setGlobalDate(currentInputDatepicker);
                IntervalCalendar.Popup.close(popupIntervalCalendar);
            });

            // Переключение состояния попапа по клику на кнопку
            $('[data-interval-input-date-btn]').on('click', function(){
                currentInputDatepicker = $(this).closest('[data-interval-input-date-wrap]').find('[data-interval-input-date]');

                IntervalCalendar.Popup.toggle(popupIntervalCalendar, currentInputDatepicker);
            });

            // Закрытие попапа по клику на кнопку
            $('[data-interval-close-popup-calendar-filter]').on('click', function(){
                IntervalCalendar.Popup.close(popupIntervalCalendar);

                setTimeout(function(){
                    IntervalCalendar.resetSelectDatepicker();
                }, 350);
            });

            // Отлавливаем событие клика вне попапа, вне кнопки открыть/закрыть попап,
            // вне табов переключения дат и при его выполнении закрываем попап
            $(document).on('click', function(event){
                let _target = $(event.target);

                if( _target.closest('[data-interval-inner-popup-calendar-filter]').length ||
                    _target.closest('[data-interval-toogle-popup-calendar-filter]').length ||
                    _target.closest('[data-interval-close-popup-calendar-filter]').length ||
                    _target.closest('[data-interval-popup]').length ||
                    _target.closest('[data-interval-btn-subscription-footer]').length||
                    _target.closest('[data-handler="prev"].ui-datepicker-prev')||
                    _target.closest('[data-handler="next"].ui-datepicker-next')) {
                    return;
                }
                event.stopPropagation();
                IntervalCalendar.Popup.close(popupIntervalCalendar);

                setTimeout(function(){
                    IntervalCalendar.resetSelectDatepicker();
                }, 350);
            });

            $(window).resize(function (event) {

                if (IntervalCalendar.Popup.isOpen()) {
                    if (Scrollbar.isActive()) {
                        $('body').css('padding-right', Scrollbar.getWidth() + 'px');
                    } else {
                        $('body').removeAttr('style');
                    }

                    if(Media.detect().isMobile){
                        $('body').removeClass('page_overflow');
                    }else{
                        $('body').addClass('page_overflow');
                    }
                }
            });

            // Обработка стрелок вперёд/назад на мобилке
            /*$('[data-interval-btn-next-calendar-filter]').on('click', function(){
                IntervalCalendar.Popup.mobileNextSlide($(this));
            });
            $('[data-interval-btn-prev-calendar-filter]').on('click', function(){
                IntervalCalendar.Popup.mobilePrevSlide($(this));
            });*/
        },
        open: function(popupIntervalCalendar, field){

            if(!Media.detect().isMobile){
                $('body').addClass('page_overflow');
            } else {
                var topPositionCalendarMobile = field.offset().top + field.outerHeight() - popupIntervalCalendar.parent().offset().top;
                popupIntervalCalendar.css('top', topPositionCalendarMobile);
            }

            $('body').addClass('page_calendar-popup-open');

            if (Scrollbar.isActive() && !Media.detect().isMobile) {
                $('body').css('padding-right', Scrollbar.getWidth() + 'px');
            } else {
                $('body').css('padding-right', '0');
            }

            if (field.val() != '') {
                IntervalCalendar.setParseIntervalDate(field);
            }

            popupIntervalCalendar.addClass('open').animate({
                opacity: 1
            }, 300, function(){});

            // Инициализируем скролл табов
            let tabNavIntervalCalendar = $('[data-interval-nav-tab-calendar]');
            if(tabNavIntervalCalendar.length) {

                let myScrollIntervalCalendarTab;

                if (!(tabNavIntervalCalendar.find('.scroll-content').length) ){
                    // Добавляем внутреннюю обертку скроллящейся части
                    tabNavIntervalCalendar.wrapInner('<div class="scroll-content"></div>');
                    // Добавляем стрелки вперёд-назад
                    tabNavIntervalCalendar.append('<div class="scroll-left"></div><div class="scroll-right"></div>');

                    tabNavIntervalCalendar.find('.scroll-content').css('min-width', IntervalCalendar.ScrollTabs.minWidthTabs(tabNavIntervalCalendar) + 'px');
                }

                IntervalCalendar.ScrollTabs.initScrollContent('[data-interval-nav-tab-calendar]', myScrollIntervalCalendarTab);
            }
        },
        close: function(popupIntervalCalendar){
            popupIntervalCalendar.animate({ opacity: 0 }, 300, function(){
                $(this).removeClass('open');
                $('body')
                    .removeClass('page_overflow')
                    .removeClass('page_calendar-popup-open')
                    .removeAttr('style');

                $('[data-interval-nav-tab-calendar]').find('[data-interval-tab-calendar-filter]').removeClass('active');
            });
        },
        toggle: function(popupIntervalCalendar, field){
            if(popupIntervalCalendar.hasClass('open')) {
                IntervalCalendar.Popup.close(popupIntervalCalendar);
            }else{
                IntervalCalendar.Popup.open(popupIntervalCalendar, field);
            }
        },
        isOpen: function () {
            return $('body').hasClass('page_calendar-popup-open');
        }/*,
        mobileNextSlide: function(_this){
            if(!_this.hasClass('disabled')) {
                _this.addClass('disabled');
                $('[data-interval-content-popup-calendar-filter]').addClass('finish');
                $('[data-interval-btn-prev-calendar-filter]').removeClass('disabled');
            }
        },
        mobilePrevSlide: function(_this){
            if(!_this.hasClass('disabled')) {
                _this.addClass('disabled');
                $('[data-interval-content-popup-calendar-filter]').removeClass('finish');
                $('[data-interval-btn-next-calendar-filter]').removeClass('disabled');
            }
        }*/
    }
}

$(document).ready(function($) {
    if($('[data-interval-datepicker-calendar]').length) {
        $.datepicker.setDefaults( $.datepicker.regional[langId] );
    }

    // Инициализируем табы
    let tabIntervalCalendar = $('[data-interval-tab-calendar-filter]');
    if(tabIntervalCalendar.length) {

        tabIntervalCalendar.on('click', function(e){
            e.preventDefault();
            IntervalCalendar.initTabs($(this), tabIntervalCalendar);
        });
    }

    // Инициализируем календари
    let datepickerIntervalCalendars = $('[data-interval-datepicker-calendar]');
    if(datepickerIntervalCalendars.length) {
        var dataDateStartIntervalCalendar = datepickerIntervalCalendars.data('loaddate-start'),
            dataDateFinishIntervalCalendar = datepickerIntervalCalendars.data('loaddate-finish');

        IntervalCalendar.initIntervalCalendar(datepickerIntervalCalendars);

        // Устанавливаем изначально в календаре текущую дату
        hiddenDateStart = new Date();
        hiddenDateFinish = new Date();
        IntervalCalendar.setDateDatepicker(hiddenDateStart, hiddenDateFinish);

        datepickerIntervalCalendars
            .on('mouseenter', 'tbody td:not(.ui-state-disabled)', function(){
                var $this = $(this),
                    extensionRange = datepickerIntervalCalendars.datepicker('widget').data('datepickerExtensionRange'),
                    msDateStart = new Date(extensionRange.startDate).getTime(),
                    msDateEnd = new Date(extensionRange.endDate).getTime(),
                    hoverDate = new Date($this.data('year'), $this.data('month'), $this.find('span, a').text());

                if(msDateStart == msDateEnd){
                    datepickerIntervalCalendars.find('tbody td:not(.ui-state-disabled)').each(function(index, el) {
                        var $currEl = $(this),
                            currDate = new Date($currEl.data('year'), $currEl.data('month'), $currEl.find('span, a').text());

                        if (currDate.getTime() > msDateStart && currDate.getTime() < hoverDate.getTime() && (extensionRange.step == 1)) {
                            $currEl.addClass('hover-interval');
                        }else{
                            $currEl.removeClass('hover-interval');
                        };
                    });

                    var $popupInterval = $('[data-select-interval-date-calendar-filter]'),
                        htmlStartDate = hiddenDateStart.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' }),
                        htmlFinishDate = hoverDate.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' });;

                    if((extensionRange.step == 1) && (hoverDate.getTime() > msDateStart)) {
                        $popupInterval.html(htmlStartDate + ' - ' + htmlFinishDate);
                    }else{
                        $popupInterval.html(htmlStartDate + ' - ' + htmlStartDate);
                    }
                }
            })
            .on('mouseleave', 'tbody td:not(.ui-state-disabled)', function(){
                var extensionRange = datepickerIntervalCalendars.datepicker('widget').data('datepickerExtensionRange'),
                    dateStart = new Date(extensionRange.startDate).getTime(),
                    htmlStartDate = hiddenDateStart.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' }),
                    htmlFinishDate = hiddenDateFinish.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' });

                datepickerIntervalCalendars.find('tbody td').removeClass('hover-interval');

                if(extensionRange.step == 0) {
                    $('[data-select-interval-date-calendar-filter]').html(htmlStartDate + ' - ' + htmlFinishDate);
                }else{
                    $('[data-select-interval-date-calendar-filter]').html(htmlStartDate + ' - ' + htmlStartDate);
                }
            });
    }

    // Инициализируем настройки попапа
    let popupIntervalCalendar = $('[data-interval-popup-calendar-filter]');
    if(popupIntervalCalendar.length) {
        IntervalCalendar.Popup.init(popupIntervalCalendar);
    }


});

export default {
    setGlobalDate: IntervalCalendar.setGlobalDate,
    clearCalendar: IntervalCalendar.clearCalendar,
    setDateDatepicker: IntervalCalendar.setDateDatepicker
};


// WEBPACK FOOTER //
// ./components/calendar-input-interval.js